// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__283sa","validationTips":"StatementDescriptor_validationTips__2TEK-"};